import React from 'react';
import { Box, Paper, Typography, RadioGroup, FormControlLabel, Radio, Stack } from '@mui/material';

export default function QuestionDisplay({ question, index, total, selected, onSelect }) {
  if (!question) return null;

  const getOptionDetails = (opt) => {
    if (typeof opt === 'object' && opt !== null) {
      return {
        text: opt.text || '',
        imageUrl: opt.imageUrl || null
      };
    }
    return {
      text: String(opt || ''),
      imageUrl: null
    };
  };

  const hasImageOptions = question.options && question.options.some(opt => typeof opt === 'object' && opt !== null && opt.imageUrl);

  return (
    <Paper sx={{ p: 3, mb: 2 }}>
      <Typography variant="subtitle2" color="text.secondary">
        Question {index + 1} of {total}
      </Typography>
      <Typography variant="h6" sx={{ mb: 2 }}>{question.text}</Typography>
      
      <RadioGroup
        value={selected ? (typeof selected === 'object' ? selected.text : selected) : ''}
        onChange={e => {
          const selectedOpt = question.options.find(opt => {
            const details = getOptionDetails(opt);
            return details.text === e.target.value;
          });
          onSelect(selectedOpt || e.target.value);
        }}
      >
        <Box 
          sx={{ 
            display: 'grid', 
            gridTemplateColumns: hasImageOptions ? { xs: '1fr', md: '1fr 1fr' } : '1fr', 
            gap: 2,
            mt: 1
          }}
        >
          {question.options.map((opt, i) => {
            const { text, imageUrl } = getOptionDetails(opt);
            const isSelected = selected ? (typeof selected === 'object' ? selected.text === text : selected === text) : false;
            return (
              <Paper 
                key={i} 
                variant="outlined" 
                sx={{ 
                  p: 1.5, 
                  borderRadius: 2,
                  borderColor: isSelected ? 'primary.main' : 'divider',
                  bgcolor: isSelected ? 'action.selected' : 'background.paper',
                  display: 'flex',
                  alignItems: imageUrl ? 'flex-start' : 'center'
                }}
              >
                <FormControlLabel
                  value={text}
                  control={<Radio />}
                  label={
                    <Box sx={{ py: 0.5 }}>
                      <Typography sx={{ whiteSpace: 'pre-wrap', fontWeight: isSelected ? 500 : 400 }}>{text}</Typography>
                      {imageUrl && (
                        <Box 
                          sx={{ 
                            mt: 1, 
                            textAlign: 'center', 
                            overflow: 'hidden', 
                            borderRadius: 1,
                            border: '1px solid',
                            borderColor: 'divider',
                            p: 0.5,
                            bgcolor: 'background.paper'
                          }}
                        >
                          <Box 
                            component="img" 
                            src={imageUrl} 
                            alt={text}
                            sx={{ 
                              maxHeight: 150, 
                              maxWidth: '100%', 
                              objectFit: 'contain',
                              transition: 'transform 0.2s ease-in-out',
                              '&:hover': {
                                transform: 'scale(1.05)'
                              }
                            }} 
                          />
                        </Box>
                      )}
                    </Box>
                  }
                  sx={{ width: '100%', m: 0 }}
                />
              </Paper>
            );
          })}
        </Box>
      </RadioGroup>
    </Paper>
  );
}
